import get from 'lodash-es/get';

/**
 *
 * @param {{
 *  appName?: string;
 *  appVersion?: string;
 *  stepName?: string;
 *  loggerBaseApiUrl: string;
 * }} params
 * @param {*} error
 * @returns
 */
export default function logReactError(_ref, error) {
  let {
    appName,
    appVersion,
    stepName,
    loggerBaseApiUrl
  } = _ref;
  if (!loggerBaseApiUrl) {
    console.warn('[@wkda/funnel-components:logReactError] loggerBaseApiUrl is not configured');
    return;
  }
  if (!appName) {
    console.warn('[@wkda/funnel-components:logReactError] appName is not configured');
  }
  if (!appVersion) {
    console.warn('[@wkda/funnel-components:logReactError] appVersion is not configured');
  }
  return fetch(loggerBaseApiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      level: 'error',
      appName,
      appVersion,
      stepName,
      referrer: window.location.href,
      payload: {
        type: 'react-error',
        message: get(error, 'message'),
        stack: get(error, 'stack')
      }
    })
  });
}